import { patch, getAuthenticatedRequestConfig } from '../client'

export const updateNotificationInterectedAt = (params = {}) => {
  const { notificationId, actionId } = params

  // eslint-disable-next-line implicit-arrow-linebreak
  return patch(`/v1/notifications/${notificationId}/actions/${actionId}`, {
    ...params
  })
    .then((response) => response)
    .catch((error) => Promise.reject(error))
}

export const updateAuthenticatedNotificationInterectedAt = (
  baseURL,
  authToken,
  authHeader,
  authScheme,
  params = {}
) => {
  const requestConfig = getAuthenticatedRequestConfig(
    baseURL,
    authToken,
    authHeader,
    authScheme,
    params
  )

  return updateNotificationInterectedAt(requestConfig)
}

export default updateNotificationInterectedAt
